const routes = {
  base: "/recruiter-insights",
  signup: "/signup",
  login: "/login",
  forgotPasswordUrl: "/app/user?op=lostpassword",
  yourPerformance: "/your-performance",
  companyOverview: "/company-overview",
  colleagues: "/colleagues",
  talentRadar: "/talentradar",
  administration: "/administration",
  impersonate: "/impersonate",
  overview: "/",
  root: "/",
  xing: "/?sc_o=xri_app_switcher_to_xing_click",
  help: "https://recruiting.xing.com/de/hilfe-center",
  helpEN: "https://recruiting.xing.com/en/helpcenter",
  about: "https://www.xing.com/legalnotice",
  termsAndConditions: "https://www.xing.com/terms",
  privacyPolicy: "https://www.xing.com/privacy",
  security: "https://corporate.xing.com/english/company/security-at-xing/",
  yourSettings: `${window.location.origin}/recruiting-settings?sc_o=profile_personal_settings_xri`,
}

export { routes }
